import CardBody from "components/card/CardBody";
import CustomCard from "components/card/CustomCard";
import CustomCardHeader from "components/card/CustomCardHeader";
import ComponentLoader from "components/ComponentLoader";
import { ComponentNoData } from "components/ComponentLoader";
import { ComponentError } from "components/ComponentLoader";
import ConfirmModal from "components/ConfirmModal";
import CustomButton from "components/CustomButton";
import { SemiTransparentButton } from "components/CustomButton";
import Paginator from "components/Paginator";
import isEmpty from "lodash/isEmpty";
import PredictionLoader from "pages/dynamicUi/elements/prediction/PredictionLoader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { resetSearch } from "redux/slices/predictionSlice";
import { tryGetPredictionSearchResult } from "redux/slices/predictionSlice";
import { tryDeletePredictionCampaign } from "redux/slices/predictionSlice";
import { tryUpdatePredictionCampaign } from "redux/slices/predictionSlice";
import { tryGetPredictionCampaign } from "redux/slices/predictionSlice";
import PredictionCampaign from "./components/PredictionCampaign";
import PredictionCampaignForm from "./components/PredictionCampaignForm";


const Predictions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState()

  const {
    campaign: { data, loading, processing, error, init, page, totalPage }, searchResult
  } = useSelector((state) => state.prediction)

  const location = useLocation()

  const searchId = new URLSearchParams(location.search).get('id')

  useEffect(() => {
    if (searchId) {
      dispatch(tryGetPredictionSearchResult(searchId))
    } else {
      dispatch(tryGetPredictionCampaign())
    }
  }, [searchId])

  useEffect(() => {
    setShowModal()
    setShowConfirmModal()
  }, [data, searchResult.data])

  const removepredictionCampaign = () => {
    dispatch(
      tryDeletePredictionCampaign(
        showConfirmModal.id
      ),
    )
  }

  const onToggleStatus = (campaignId, active) => {
    dispatch(tryUpdatePredictionCampaign(
      {
        prediction_campaign_id: campaignId,
        payload: {
          active: !active,
        }
      }))
  }

  const onPageClick = (page) => {
    dispatch(tryGetPredictionCampaign(page))
  }

  const searchRetry = () => {
    dispatch(tryGetPredictionSearchResult(searchId))
  }

  const clearSearchResult = () => {
    dispatch(resetSearch())
    setTimeout(() => {
      navigate(`/predictions`, { replace: true })
    }, 0)
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <div className="flex items-center justify-between w-full">
                <h2 className="text-2xl text-white">Prediction Campaigns</h2>
                <SemiTransparentButton onClick={() => setShowModal({})}>
                  + Add New
                </SemiTransparentButton>
              </div>
            </CustomCardHeader>
            <CardBody>
              {!isEmpty(searchId)
                ?
                <div>
                  <div className="flex justify-between">
                    <h2 className="mb-4">Search Result</h2>
                  </div>
                  {
                    searchResult.error && !searchResult.init ?
                      <ComponentError errorMsg={searchResult.error} retry={searchRetry} />
                      : searchResult.loading || !searchResult.init ?
                        <PredictionCampaignLoader />
                        : isEmpty(searchResult.data) && searchResult.init ?
                          <ComponentNoData />
                          : <PredictionCampaign campaign={searchResult.data}
                            disabledToggle={processing}
                            toggleStatus={(e) => {
                              onToggleStatus(searchResult.data.id, searchResult.data.active)
                            }}
                            onEdit={(e) => {
                              e.preventDefault()
                              setShowModal(searchResult.data)
                            }}
                            onDelete={(e) => {
                              e.preventDefault()
                              setShowConfirmModal({
                                id: searchResult.data.id
                              })
                            }}
                            onResult={(e) => {
                              e.preventDefault()
                              navigate(`/predictions/${searchResult.data.id}/result`, { replace: false })
                            }}
                          />

                  }
                </div>
                : <>
                  {
                    error && !init ?
                      <ComponentError errorMsg={error} retry={() => onPageClick(page)} />
                      : loading || !init ?
                        <PredictionCampaignLoader />
                        : isEmpty(data) && init ?
                          <ComponentNoData />
                          :
                          data?.map((d, index) => {
                            return <PredictionCampaign campaign={d}
                              key={`prediction-campaign-${index}`}
                              disabledToggle={processing}
                              toggleStatus={(e) => {
                                onToggleStatus(d.id, d.active)
                              }}
                              onEdit={(e) => {
                                e.preventDefault()
                                setShowModal(d)
                              }}
                              onDelete={(e) => {
                                e.preventDefault()
                                setShowConfirmModal({
                                  id: d.id
                                })
                              }}
                              onResult={(e) => {
                                e.preventDefault()
                                navigate(`/predictions/${d.id}/result`, { replace: false })
                              }}
                            />
                          })
                  }
                </>
              }

            </CardBody>
            {
              !isEmpty(searchId) &&
              <div className="flex justify-end">
                <CustomButton onClick={clearSearchResult}>
                  Clear
                </CustomButton>
              </div>
            }

          </CustomCard>
        </div>

      </div>
      <PredictionCampaignForm
        loading={processing || searchResult.processing}
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <ConfirmModal
        children="This will remove nominee. Are you sure?"
        disabled={processing || searchResult.processing}
        showModal={!!showConfirmModal}
        setShowModal={() => setShowConfirmModal()}
        onConfirm={removepredictionCampaign}
        loading={processing || searchResult.processing}
      />

      {isEmpty(searchId) &&
        <Paginator
          currentPage={page}
          totalPages={totalPage}
          onClick={onPageClick}
          loading={totalPage === -1}
        />
      }
    </div>
  )

}

export default Predictions;


function PredictionCampaignLoader({ count = 4 }) {
  return (
    <div className={`container flex flex-col space-y-4 w-full px-3 mb-4`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={`prediction-${index}`} className="h-24 flex p-4 rounded-md animate-pulse bg-rand-200 z-1">
          <div className="flex flex-col justify-center ml-2 space-y-2 w-full">
          </div>

        </div>
      ))}
    </div>
  );

}
